<template>
    <div class="material-list">
        <div class="material-item" v-for="(item, index) in listData" @click="listItemClick(item)" :key="index">
            <div class="material-tag tag" v-if="item.saleprice == 0">免费</div>
            <div class="material-collect" v-if="showItemCollect" @click.stop="setListItemCollect(item)">
                取消收藏 <i class="el-icon-star-on"></i>
            </div>
            <div class="material-cover">
                <img :src="item.thumbnailurl" alt="封面"/>
            </div>
            <div class="material-info">
                <div class="material-title" :title="item.materialtitle">{{ item.materialtitle }}</div>
                <div class="material-tags" ref="tags">
                    <span
                        class="tag-item"
                        v-for="(tag, index) in item.materialtag"
                        v-show="index < showTagsLength"
                        :title="tag"
                        :key="index"
                    >{{ tag }}</span
                    >
                    <span class="count" v-if="showTagsLength < item.materialtag.length"
                    >+{{ item.materialtag.length - showTagsLength }}</span
                    >
                </div>
                <div class="material-meta">
                    <span class="page-count">{{ item.pagesize }}页</span>
                    <span class="date" :title="item.releasedate">{{ item.releasedate }}</span>
                </div>
                <!-- 将作者信息隐藏 -->
                <!-- <div class="material-author" v-if="!showItemType"> -->
                <div class="material-author" v-if="false">
                    <img :src="avatar(item.profilepicurl)" class="author-avatar" alt="作者头像"/>
                    <span class="author-name" :title="item.shopname">{{ item.shopname }}</span>
                </div>
                <!-- <div class="material-type" v-else>
                    <span>{{ item.materialtypetext }}</span>
                </div> -->
            </div>
        </div>
    </div>
</template>
<script>
import DEFAULT_AVATAR from '@/views/material-market/images/icon_user.png';

export default {
    name: 'materialList',
    data() {
        return {
            showTagsLength: 3,
            timer: null
        };
    },
    props: {
        data: {
            type: Array,
            default: () => []
        },
        showItemType: {
            type: Boolean,
            default: false
        },
        showItemCollect: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        listData() {
            let data = this.data.map((e) => {
                return {
                    ...e,
                    materialtag: e.materialtag ? e.materialtag.split(';') : ''
                };
            });
            this.handleListItemTagsShow(20);
            return data;
        }
    },
    methods: {
        avatar(avatar) {
            return avatar || DEFAULT_AVATAR;
        },
        handleListItemTagsShow(time = 100) {
            this.$nextTick(() => {
                this.timer && clearTimeout(this.timer);
                this.timer = setTimeout(() => {
                    this.$refs.tags && this.$refs.tags.length &&
                    [this.$refs.tags[0]].forEach((tags) => {
                        let tagsWidth = tags.getBoundingClientRect().width;
                        let showLength = Math.floor(tagsWidth / 64);
                        this.showTagsLength = showLength;
                    });
                }, time);
            });
        },
        listItemClick(data) {
            this.$emit('listItemClick', data);
        },
        setListItemCollect(data) {
            this.$emit('setListItemCollect', data);
        }
    },
    mounted() {
        window.addEventListener('resize', () => {
            this.handleListItemTagsShow()
        });
    },
    destroyed() {
        window.removeEventListener('resize', this.handleListItemTagsShow);
    }
};
</script>
<style lang="scss" scoped>
@import '../style/common.scss';
@import './style/material-list.scss';
</style>
